const fa = {
  100000001:'اطلاعات کلیدی',
  100000002:'نام توکن',
  100000003:'سازنده کپی',
  100000004:'زمان ایجاد نمونه',
  100000005:"اطلاعات پایه",
  100000006:'بلاکچین/پروتکل مرتبط',
  100000007:'آدرس قرارداد هوشمند',
  100000008:'تاریخ صدور',
  100000009:'عرضه کل',
  100000010:'تامین گردش',
  100000011:'ارزش بازار',
  100000012:'اطلاعات',
  100000013:'اطلاعات شبکه‌های اجتماعی',
  100000014:'وب سایت',
  100000015:'وایت پیپر',
  100000016:'مرورگر بلاکچین',
  100000017:'امتیاز پروژه',
  100000018:'رتبه بندی ',
  100000019:'برتر',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'زمان به روز شد',
  100000027:'امتیاز امنیت',
  100000028:'امتیاز امنیت قرارداد',
  100000029:'آمار پروژه‌های پرخطر',
  100000030:'جزئیات کد قرارداد',
  100000031:'مالیات خرید',
  100000032:'مالیات فروش',
  100000033:'آیا هانی‌پات است',
  100000034:'آیا می‌توان دوباره Mint کرد',
  100000035:'آیا لیست سیاه وجود دارد',
  100000036:'آیا لیست سفید وجود دارد',
  100000037:'آیا ضد نهنگ است',
  100000038:'آیا می‌توان نرخ مالیات را تغییر داد',
  100000039:'آیا متن‌باز است',
  100000040:'آیا دارنده‌های پنهان وجود دارند',
  100000041:'آیا می‌توان خود را نابود کرد',
  100000042:'آیا قرارداد پراکسی است',
  100000043:'آیا می‌توان موجودی را تغییر داد',
  100000044:'آیا می‌توان فراخوانی خارجی انجام داد',
  100000045:'آیا می‌توان مالکیت را دوباره به دست آورد',
  100000046:'آیا دوره سرد برای تراکنش‌ها وجود دارد',
  100000047:'آیا می‌توان انتقال را متوقف کرد',
  100000048:'مالکیت رها نشده است',
  100000049:'آیا ضد نهنگ قابل تنظیم است',
  100000050:'تعداد اعشار بیش از حد است',
  100000051:'روش‌های Mint و Burn عمومی',
  100000052:'آیا سوزاندن توکن‌ها مقدار کل را به‌روز می‌کند',
  100000053:'آیا سوزاندن توکن‌ها موجودی را به‌روز می‌کند',
  100000054:'آیا انتقال به خود باعث افزایش موجودی می‌شود',
  100000055:'آیا انتقال توکن بیش از موجودی نامعتبر خواهد بود',
  100000056:'موجودی در طول انتقال به‌روز نمی‌شود',
  100000057:'آیا موجودی گیرنده مصرف می‌شود',
  100000058:'آیا هنگام فراخوانی TransferFrom بیش از موجودی شکست می‌خورد',
  100000059:'آیا روش BurnFrom مقدار کل را به‌روز می‌کند',
  100000060:'تشخیص مالیات خرید توکن بالای ۵٪ به عنوان نرخ مالیات بالا در نظر گرفته می‌شود',
  100000061:'تشخیص مالیات فروش توکن بالای ۵٪ به عنوان نرخ مالیات بالا در نظر گرفته می‌شود',
  100000062:'بررسی کنید که آیا توکن یک کلاهبرداری هانی‌پات است',
  100000063:'بررسی کنید که آیا می‌توان توکن‌های بیشتری ضرب کرد',
  100000064:'بررسی کنید که آیا توکن لیست سیاهی دارد که می‌تواند کاربران را از مبادله یا انتقال توکن‌ها محدود کند',
  100000065:'بررسی کنید که آیا توکن لیست سفیدی دارد که به آدرس‌ها اجازه می‌دهد هر گونه محدودیتی را دور بزنند',
  100000066:'بررسی کنید که آیا توکن مکانیزم ضد نهنگ دارد',
  100000067:'بررسی کنید که آیا توکن مالیات دارد و آیا مالیات توسط نقش‌های ویژه قابل تغییر است',
  100000068:'بررسی کنید که آیا توکن در مرورگر بلاک‌چین تأیید شده است',
  100000069:'بررسی کنید که آیا توکن یک مالک پنهان دارد که می‌تواند قرارداد را دستکاری کند حتی اگر به نظر می‌رسد مالکیت لغو شده است',
  100000070:'بررسی کنید که آیا توکن می‌تواند خود را نابود کند',
  100000071:'بررسی کنید که آیا توکن یک قرارداد پروکسی است که تماس‌های تابع را به یک قرارداد پیاده‌سازی می‌سپارد',
  100000072:'بررسی کنید که آیا موجودی توکن می‌تواند توسط نقش‌های ویژه تغییر کند',
  100000073:'بررسی کنید که آیا توکن قراردادهای خارجی را فراخوانی می‌کند',
  100000074:'بررسی کنید که آیا توکن یک در پشتی برای بازپس‌گیری مالکیت دارد',
  100000075:'بررسی کنید که آیا توکن مکانیزم تأخیر انتقال دارد',
  100000076:'بررسی کنید که آیا تجارت توکن می‌تواند توسط نقش‌های ویژه متوقف شود',
  100000077:'بررسی کنید که آیا امتیاز مالک لغو شده است',
  100000078:'بررسی کنید که آیا مکانیزم‌های ضد نهنگ توکن می‌تواند توسط نقش‌های ویژه تغییر کند',
  100000079:'بررسی کنید که آیا مقدار بازگشتی تابع decimals() بیشتر یا مساوی ۵ است',
  100000080:'بررسی کنید که آیا فراخوانی توابع mint() و burn() توسط کاربران تصادفی منجر به برگشت می‌شود',
  100000081:'بررسی کنید که آیا فراخوانی تابع burn() میزان totalSupply را به درستی به‌روزرسانی می‌کند',
  100000082:"بررسی کنید که آیا فراخوانی تابع burnFrom() میزان تخصیص را به درستی به‌روزرسانی می‌کند",
  100000083:'بررسی کنید که آیا فراخوانی تابع transfer() با گیرنده‌ای که همان فرستنده تراکنش است، موجودی فرستنده را افزایش می‌دهد',
  100000084:'بررسی کنید که آیا فراخوانی تابع transfer() با مقداری بیشتر از موجودی منجر به شکست می‌شود',
  100000085:"بررسی کنید که آیا پس از فراخوانی تابع transferFrom()، تخصیص هزینه‌کننده به درستی به‌روزرسانی می‌شود",
  100000086:"بررسی کنید که آیا فراخوانی تابع transferFrom() از موجودی هزینه‌کننده استفاده می‌کند",
  100000087:"بررسی کنید که آیا پس از فراخوانی transferFrom()، مقدار مجاز به‌درستی به‌روزرسانی شده است یا اگر مقدار نامعتبر باشد، تراکنش بازگردانده می‌شود.",
  100000088:"بررسی کنید که آیا فراخوانی تابع burnFrom() باعث به‌روزرسانی صحیح totalSupply می‌شود.",
  100000089:'بررسی کنید که آیا اختیارات ضرب سکه وجود دارد',
  100000090:'بررسی کنید که آیا اختیارات مسدود‌سازی وجود دارد',
  100000091:'بررسی کنید که آیا متادیتا قابل تغییر است',
  100000092:'حرج',
  100000093:'كبير',
  100000094:'متوسط',
  100000095:'ثانوي',
  100000096:'إعلامي',
  100000097:'آیا مجوز mint رها شده است',
  100000098:'آیا مجوز انجماد رها شده است',
  100000099:'آیا می‌توان فراداده‌های توکن را تغییر داد',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default fa


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/fa.js